/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React from 'react';
import AdvertisementList from './../AdvertisementList';
import BookmakerRegPanelContainer from './../BookmakerRegPanel';
import { checkForRegPanel } from '../utils/contentHubHelper';


/**
 * Component that is used for rendering <Sidebar />
 * It consists of:
 * <BookmakerRegPanelContainer />
 * <AdvertisementList />
 */
function Sidebar() {
    return (
        <aside className="ui-sidebar ui-sidebar_paddingless ui-sidebar_marginless">
            {checkForRegPanel() && <BookmakerRegPanelContainer />}
            <AdvertisementList />
        </aside>
    );
}

export { Sidebar as default };



// WEBPACK FOOTER //
// ./src/js/Sidebar/Sidebar.js